import React, { useState } from 'react';

import { Dientes } from '../Odontologia/Dientes';
import { Grid } from '@material-ui/core';
import { ModalAltaPractica } from '../Odontologia/ModalAltaPractica';
import { ModalEvolucionOdontologia } from '../Odontologia/ModalEvolucionOdontologia';
import { ModalImagenOdontograma } from '../Odontologia/ModalImagenOdontograma';

export const TabOdontologia = (props) => {
  const [nroDiente, setNroDiente] = useState('');
  const { hce, disabled } = props;
  const dienteSeleccionado = (e) => {
    setNroDiente(e);
  };

  const cerrarModalAlta = () => setNroDiente('');

  return (
    <React.Fragment>
      <Grid container spacing={6}>
        <Grid item xs={12} md={6} lg={6}>
          <Dientes dienteSeleccionado={dienteSeleccionado} disabled={disabled} />
        </Grid>
        <Grid item xs={12} md={6} lg={6}>
          <ModalImagenOdontograma hce={hce} disabled={disabled}/>
        </Grid>
        <Grid item xs={12} md={6} lg={6}>
          {nroDiente !== '' && (
            <ModalAltaPractica
              hce={hce}
              nroDiente={nroDiente}
              cerrarModal={cerrarModalAlta}
              disabled={disabled}
            />
          )}
        </Grid>
        <Grid item xs={12} md={6} lg={6}>
          <ModalEvolucionOdontologia hce={hce} disabled={disabled} />
        </Grid>
      </Grid>
    </React.Fragment>
  );
};
